import React from 'react'

import { useIsMobile } from '@/shared/hooks/useIsMobile'
import GlobalSearch from '@/widgets/global-search/GlobalSearch'
import LatestTransactions from '@/widgets/latest-transactions/LatestTransactions'

const Home: React.FC = () => {
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        paddingTop: isMobile ? '4vh' : 'var(--space-3xl)',
        minHeight: '80vh',
        paddingLeft: isMobile ? 'var(--space-xs)' : '0',
        paddingRight: isMobile ? 'var(--space-xs)' : '0',
      }}
    >
      <h1
        style={{
          fontSize: isMobile ? 'var(--font-size-h2)' : 'var(--font-size-hero)',
          fontWeight: 700,
          letterSpacing: isMobile ? 'var(--tracking-title)' : 'var(--tracking-hero)',
          marginBottom: isMobile ? 'var(--space-lg)' : 'var(--space-20)',
          textAlign: 'center',
          lineHeight: isMobile ? 1.3 : 1.2,
        }}
      >
        Search the <span style={{ color: 'var(--brand-primary)' }}>YesFi</span> Chain
      </h1>

      <GlobalSearch
        variant="home"
        style={{
          width: '100%',
          maxWidth: 'var(--search-max-width)',
          borderRadius: 'var(--radius-lg)',
          overflow: 'hidden',
          boxShadow: 'var(--shadow-search)',
        }}
      />

      <LatestTransactions />
    </div>
  )
}

export default Home
